module.exports = __webpack_public_path__ + "img/undraw-browsing.815115e7.svg";